import { Trans, useTranslation } from 'react-i18next';
import { BulletPoints } from '@/web/components/BulletPoints/BulletPoints';

export const BulletPointsI18n = ({
  i18nKey,
  values,
  interpolate,
}: IBulletPointsI18nProps) => {
  const { t } = useTranslation();
  const bulletPoints = t(i18nKey, {
    returnObjects: true,
    ...values,
  });

  if (Array.isArray(bulletPoints)) {
    const elements = interpolate
      ? bulletPoints.map((point) => (
          <span key={point}>
            <Trans i18nKey={point} />
          </span>
        ))
      : bulletPoints;
    return <BulletPoints points={elements} />;
  }

  return null;
};

export interface IBulletPointsI18nProps {
  i18nKey: string;
  values?: object;
  interpolate?: boolean;
}
